export default "__VITE_ASSET__8d6a4006__"